/* src/app/components/regional-officer/regional-officer.component.css */
/*# sourceMappingURL=regional-officer.component.css.map */
